import {validate as validateEmail} from "email-validator"
import Config from "../config"
import Data from "../data"
import Util from "../util"

const _validate = (obj, requiredFields, emailFields) => {
  let errorFields = {email:[], required:[]}
  // email fields
  if(emailFields) {
    emailFields.forEach(key => {
      if(!validateEmail((obj[key] || "").trim())) {
        errorFields.email.push(key)
      }
    })
  }

  // required fields
  if(requiredFields) {
    requiredFields.forEach(key => {
      if((obj[key] || "").trim().length === 0) {
        errorFields.required.push(key)
      }
    })
  }

  // return result
  let valid = errorFields.required.length === 0 && errorFields.email.length === 0
  return {
    valid, errorFields
  }
}

const _getFieldLabels = (collection, keys) => {
  let labels = keys
    .map(key => {
      let field = collection.find(o => o.field === key)
      if(field) {
        return field.label
      }
      else {
        return null
      }
    })
    .filter(n => n !== null)
  return labels
}

const validateActivities = (activities) => {
  let valid = true
  let message = ""
  if((activities || []).length === 0) { 
    valid = false
    message = "Es ist noch kein Erlebnis in deinem Warenkorb."
  }
  else if(!Data.Cart.hasMinimalValue()) {
    valid = false
    message = `Der Mindestbestellwert (exklusive Verpackung & Versand) beträgt ${Util.Format.currency(Config.minimalCartValue, true)}. Passe deinen Warenkorb an oder füge weitere Aktivitäten hinzu.`
  }
  return {valid, message}
}

const validatePersonalization = (personalization) => {
  let requiredFields = ["ParticipantName", "SenderName"]
  let validationResult = _validate(personalization, requiredFields, [])
  let missingRequired = _getFieldLabels(Config.personalizeFields, validationResult.errorFields.required) 
  return {
    valid:validationResult.valid,
    message:`Es fehlen folgende Angaben: ${missingRequired.join(', ')}`
  }
}

const validatePayment = (paymentAddress, isShippingDifferent, shippingAddress) => {
  // validate the payment address
  let paymentAddressValidation = _validate(paymentAddress, ["ClientFirstName", "ClientName", "ClientAddress", "ClientZip", "ClientCity"], ["ClientEmail"])
  
  let missingRequired = _getFieldLabels(Config.paymentFields, paymentAddressValidation.errorFields.required)
  let missingEmail = _getFieldLabels(Config.paymentFields,paymentAddressValidation.errorFields.email).map(s => `gültige ${s}`)
  let missing = missingRequired.concat(missingEmail)

  // if we only have payment address we can ignore validity of shipping address
  if(!isShippingDifferent) {
    return {
      valid:paymentAddressValidation.valid,
      message:`Es fehlen folgende Angaben: ${missing.join(', ')}`
    }
  }

  // validation shipping address
  let shippingAddressValidation = _validate(shippingAddress, ["ShippingFirstName", "ShippingName", "ShippingAddress", "ShippingZip", "ShippingCity"], [])
  let missing2 = _getFieldLabels(Config.shippingFields, shippingAddressValidation.errorFields.required)
  
  // return validation result
  let messages = []
  if(missing.length > 0) {
    messages.push(`Bei der Rechnungsadresse fehl${missing.length === 1 ? "t":"en"}: ${missing.join(', ')}.`)
  }
  if(missing2.length > 0) {
    messages.push(`Bei der Versandadresse fehl${missing2.length === 1 ? "t":"en"}: ${missing2.join(', ')}.`)
  }

  return {
      valid:paymentAddressValidation.valid && shippingAddressValidation.valid,
      message:messages.join(` `)
  }
}

export default {
  validateActivities,
  validatePersonalization,
  validatePayment
}